define('lq/navigationHistory',[
    'lq'
], function (lq) {
    'use strict';

    var defaultStateKey = 'trace_' + lq.getTenantName() + '_' + lq.getTenantApplicationName();

    var maxHistoryPerApplication = 50;

    var retrieveTraceFromLocalStorage = function (stateKey) {
        try {
            var state = sessionStorage.getItem(stateKey);
            return state ? JSON.parse(state) : [];
        }
        catch (e) {
            return [];
        }
    };

    var storeTraceInLocalStorage = function (stateKey, trace) {
        try {
            if (trace.length > maxHistoryPerApplication)
                trace.splice(maxHistoryPerApplication, maxHistoryPerApplication - trace.length);

            var state = JSON.stringify(trace);
            sessionStorage.setItem(stateKey, state);
        }
        catch (e) { }
    };
    
    var NavigationHistory = function (traceName, storeTrace, retrieveTrace) {
        this.storeTrace = storeTrace;
        this.retrieveTrace = retrieveTrace;
        this.stateKey = defaultStateKey + '_' + traceName;
        this.trace = this.retrieveTrace(this.stateKey);
    };

    NavigationHistory.withLocalStorage = function (traceName) {
        return new NavigationHistory(traceName, storeTraceInLocalStorage, retrieveTraceFromLocalStorage);
    };

    NavigationHistory.inMemory = function (traceName) {
        var inMemoryTrace = [];
        return new NavigationHistory(
            traceName,
            function(trace) {
                inMemoryTrace = trace;
            },
            function (trace) {
                return inMemoryTrace;
            });
    };

    NavigationHistory.prototype.push = function(url) {
        var index = url.indexOf('?');

        if (index > -1)
            url = url.substring(0, index);
        
        this.trace.push(url);
        this.storeTrace(this.stateKey, this.trace);
    };

    NavigationHistory.prototype.pop = function () {
        if (this.trace.length === 0)
            return null;
        
        var previousUrl = this.trace.pop();
        this.storeTrace(this.stateKey, this.trace);

        return previousUrl;
    };
    
    NavigationHistory.prototype.peek = function() {
        if (this.trace.length === 0)
            return null;
        return this.trace[this.trace.length - 1]
    };

    return NavigationHistory;
});
